import React from "react";
import PropTypes from "prop-types";
import { IconWarning } from "~misc/icons";

const ModalErroNegociacao = ({ isOpen, closeModal, erros = [] }) => {
  if (!isOpen) return null;
  const linkChamado = "https://votorantim.service-now.com/vcbr?id=sc_cat_item_itsm&sys_id=aa74b0b13b11d250281ff65436e45a7c";

  return (
    <div
      className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-[99999]"
      style={{ background: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="bg-white mx-4 px-10 py-8 rounded-md text-center z-[100] max-w-lg w-full">
        <span className="flex justify-center mb-3">
          <IconWarning />
        </span>
        <p className="font-bold text-lg">Envio das solicitações realizado parcialmente</p>
        <p className="mt-2 text-sm text-gray-600">
          Algumas solicitações de preço não puderam ser enviadas por erro de cadastro no cliente.
        </p>
        <p className="mt-2 text-lg font-bold text-red-600">
          Abra um chamado para o time de suporte analisar os casos com erro.
        </p>

        {erros.length > 0 && (
          <div className="mt-4 text-left">
            <p className="text-sm font-semibold mb-1">Solicitações com erro ({erros.length}):</p>
            <ul className="max-h-40 overflow-y-auto bg-gray-100 rounded space-y-1 py-2">
              {erros.map((item) => (
                <li key={`${item.cliente}-${item.produto}-${item.filial}`} className={`text-xs pb-1 px-3 border-b border-gray-200 last:border-b-0`}>
                  Cliente {item.cliente} - {item.razaoSocial} - Produto {item.produto} - {item.filial}
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="flex justify-center gap-3 mt-6">
          <button
            type="button"
            onClick={closeModal}
            className="border border-primaria text-primaria font-bold py-2 px-4 rounded hover:bg-blue-50"
          >
            Fechar
          </button>
          {linkChamado ? (
            <a href={linkChamado} target="_blank" rel="noopener noreferrer">
              <button
                type="button"
                className="bg-primaria hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
              >
                Abrir chamado
              </button>
            </a>
          ) : (
            <button
              type="button"
              onClick={closeModal}
              className="bg-primaria hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              Abrir chamado
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

ModalErroNegociacao.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  erros: PropTypes.array,
};

export default ModalErroNegociacao;
